import React, { useEffect, useRef } from "react";
import MatchListing from "./common/liveCenter/matchListing/MatchListing";
import { ColorVariables } from "../utils/general";

import CricketMatchWidgetWrap from "./widgetBoxes/cricket/CricketMatchWidgetWrap";
import CricketLeagueWidgetWrap from "./widgetBoxes/cricket/CricketLeagueWidgetWrap";
import CricketTeamWidgetWrap from "./widgetBoxes/cricket/CricketTeamWidgetWrap";
import CricketPlayerWidgetWrap from "./widgetBoxes/cricket/CricketPlayerWidgetWrap";

const CricketWidgets = ({
  dataId,
  dataType,
  sport,
  difference,
  head,
  data,
  headData,
  baseUrl,
  loadCSS,
  setDataId,
  setDataType,
  setHead,
  setDate,
  date,
  setIsLive,
  isLive,
  dataClient = false,
  websiteBaseUrl,
  dataPath,
  dataTitle,
}) => {

  const showCricketAnimationRef = useRef(null);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const res = await fetch(`${baseUrl}/settings`, {
          headers: {
            Token: process.env.REACT_APP_SETTINGS_TOKEN,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });

        if (!res.ok) throw new Error(res.statusText);

        const settings = await res.json();
        const cssVars = ColorVariables(settings);

        showCricketAnimationRef.current = settings?.data?.show_cricket_animation;

        const styleTag = document.createElement("style");
        styleTag.textContent = cssVars;
        document.head.appendChild(styleTag);
        document.querySelectorAll(".microservice-cont")?.forEach((el) => el?.classList.add("hydrated"));


        return () => {
          if (document.head.contains(styleTag)) {
            document.head.removeChild(styleTag);
          }
        };
      } catch (err) {
        console.error("Failed to load settings:", err);
      }
    };

    loadSettings();
  }, [baseUrl]);

  const commonProps = {
    dataId,
    dataType,
    sport,
    difference,
    head,
    data,
    headData,
    baseUrl,
    loadCSS,
    setDataId,
    setDataType,
    setHead,
    setDate,
    date,
    setIsLive,
    isLive,
    dataClient,
    websiteBaseUrl,
    dataPath,
    dataTitle,
    show_cricket_animation: showCricketAnimationRef.current,
  };

  if (dataType === "live-match-detail" || dataType === "live-centre") {
    return <MatchListing {...commonProps} data={data?.data} matchType="all" socketUrl={process.env.REACT_APP_SOCKET} />;
  }

  if (dataType?.startsWith("cricket-match")) {
    return <CricketMatchWidgetWrap {...commonProps} socketUrl={process.env.REACT_APP_SOCKET} />;
  }

  if (dataType?.startsWith("cricket-league-")) {
    return <CricketLeagueWidgetWrap {...commonProps} />;
  }

  if (dataType?.startsWith("cricket-team-")) {
    return <CricketTeamWidgetWrap {...commonProps} />;
  }

  if (dataType?.startsWith("cricket-player-")) {
    return <CricketPlayerWidgetWrap {...commonProps} />;
  }

  return <h1>Widget Not Found!</h1>;
};

export default CricketWidgets;
